package com.exura.features.localization.domain.model

import com.exura.features.localization.domain.manager.LocalizationManager

class Localization<T>(
    private val langSet: LangSet<T>
) {
    val current: T
        get() = langSet.getSet(LocalizationManager.currentLanguage)
}